import React from 'react';
import PropTypes from 'prop-types';
import './Configuration.css';
import ConfigurationContent from '../ConfigurationContent/ConfigurationContent';

const Configuration = () => (
  <div class="container">
    <ConfigurationContent />
  </div>

);

Configuration.propTypes = {};

Configuration.defaultProps = {};

export default Configuration;
